// import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import ContentWrapper from 'Component/ContentWrapper';
import Html from "Component/Html";
import CategoryPagination from 'Component/CategoryPagination';
import './Magazine.style';
import MagazineBlogPostCard from './MagazineBlogPostCard';
import Field from "Component/Field/Field.component";
import Loader from 'Component/Loader';
import {BLOG_CATEGORY_LISTING} from "../../../route/CategoryListing/CategoryListing.config";

export class Magazine extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    componentDidMount() {
        this.updateMeta();
        this.setHeaderState();
        this.updateBreadcrumbs();
    }

    updateBreadcrumbs() {
        const {updateBreadcrumbs, mfblog_permalink_route, categoryObject : { title }, blog_title } = this.props;
        const breadcrumbs = [
            {
                url: window.location.pathname,
                name: title
            },
            {
                url: `/${mfblog_permalink_route}`,
                name: blog_title
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateMeta() {
        const {updateMeta, redirect_code_previous, categoryObject : _category} = this.props;

        updateMeta({
            title: _category.title,
            meta_title : _category.meta_title,
            meta_keywords : _category.meta_keywords,
            meta_description : _category.meta_description,
            canonical_url: window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
    }

    getCanonicalUrl() {
        return window.location.href;
    }

    setHeaderState() {
        const {setHeaderState, history} = this.props;
        setHeaderState({
            name: BLOG_CATEGORY_LISTING,
            title: 'Blog',
            onBackClick: () => history.goBack()
        });
    }

    renderTitle() {
        const {categoryObject: {title}} = this.props;

        return (
            <h1 block="CategoryListing" elem="Title">
                {title}
            </h1>
        );
    }

    getCategoryDescription() {
        const {categoryObject: {content}} = this.props;

        if (!content)
            return null;

        return (
            <div className="CategoryListing-Description">
                <Html content={content}/>
            </div>
        );
    }

    renderLatestPostContent() {
        const {posts: {items}} = this.props;

        if (items && items.length && items[0].content) {
            return (
                <div className="Magazine_LatestPost_content">
                    <Html content={items[0].content}/>
                </div>
            );
        }

        return null;
    }

    renderLatestPost() {
        const {
            isLoaded,
            posts: {items},
            pageSize
        } = this.props;

        if (isLoaded && items.length) {
            return (
                <div className="Magazine_LatestPost">
                    {this.renderLatestPostContent()}
                    <MagazineBlogPostCard
                        key={items[0].post_id}
                        block="BlogPostCard"
                        post={items[0]}
                        topFirstMagazine={true}
                        latestMagazine={true}
                        serialNumber={0}
                    />
                    <h2 className="Magazine_title">{__('ΠΙΟ ΠΡΟΣΦΑΤΑ')}</h2>
                </div>
            );
        }

        if (isLoaded) {
            return null;
        }

        return Array.from({length: 1}, (_, i) => (
            <MagazineBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderGridDropDonw() {
        const {publish_sort_options, onDropDownChange, selectedYear} = this.props;
        if(!selectedYear) return null;
        return (
            <div className="Magazine-Grid_filter">
                <label>{__('ΤΕΥΧΗ')}</label>
                <Field
                    type='select'
                    id='selected-year'
                    selectOptions={publish_sort_options}
                    onChange={onDropDownChange}
                    value={selectedYear}
                />
            </div>
        );
    }

    renderGrid() {
        const {
            isLoaded,
            isLoading,
            posts: {items},
            pageSize,
            selectedYear,
            selectedYearCount
        } = this.props;

        if(isLoading || !selectedYear || items.length !== selectedYearCount[selectedYear]) return null;

        if (isLoaded && items.length) {
            return items.map((post, index) => (
                <MagazineBlogPostCard
                    key={post.post_id}
                    block="BlogPostCard"
                    post={post}
                    normalGrid={true}
                />
            ));
        }

        if (isLoaded) {
            return (
                <span>
                    {__('No posts in this category')}
                </span>
            );
        }

        return Array.from({length: pageSize}, (_, i) => (
            <MagazineBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderLatestGrid() {
        const {
            isLoaded,
            posts: {items},
            pageSize
        } = this.props;

        if (isLoaded && items.length) {
            return items.map((post, index) => (
                <MagazineBlogPostCard
                    key={post.post_id}
                    block="BlogPostCard"
                    post={post}
                    latestMagazine={true}
                    serialNumber={index}
                    totalPosts={items.length}
                />
            ));
        }

        if (isLoaded) {
            return (
                <span>
                    {__('No posts in this category')}
                </span>
            );
        }

        return Array.from({length: pageSize}, (_, i) => (
            <MagazineBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderTabs() {
        const {active_tab, changeTab } = this.props;

        return (
            <div className="Magazine_tabs">
                <div className="Magazine_tabs__tabs">
                    <div className={"Magazine_tabs__tab " + (active_tab === 0 ? "is-active" : "")}
                         onClick={() => changeTab(0)}>{__('ΤΕΛΕΥΤΑΙΟ ΤΕΥΧΟΣ')}</div>
                    <div className={"Magazine_tabs__tab " + (active_tab === 1 ? "is-active" : "")}
                         onClick={() => changeTab(1)}>{__('ΑΡΧΕΙΟ ΤΕΥΧΩΝ')}</div>
                </div>
                <div className="Magazine_tabs__content">
                    <div className={"Magazine_tabs__content_wrapper " + (active_tab === 0 ? "is-active" : "")}>
                        <div block="Magazine" elem="LatestGrid">
                            {this.renderLatestPost()}
                            {this.renderLatestGrid()}
                            {/*{this.renderPagination()}*/}
                            { this.renderLoadMore() }
                        </div>
                    </div>
                    <div className={"Magazine_tabs__content_wrapper " + (active_tab === 1 ? "is-active" : "")}>
                        {this.renderGridDropDonw()}
                        <div block="Magazine" elem="Grid">
                            {this.renderGrid()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLoadMore() {
        const { posts: { count, total_pages }, pageSize, loadMore } = this.props;

        if (count <= pageSize || total_pages === 1) {
            return null;
        }

        return (
            <div block="CategoryListing" elem="LoadMoreWrapper">
                <button
                    block="CategoryListing"
                    elem="LoadMoreButton"
                    mix={ { block: 'Button' } }
                    onClick={ loadMore }
                >
                    { __('Load More') }
                </button>
            </div>
        );
    }

    renderPagination() {
        const {
            isLoading,
            posts: {
                total_pages: totalPages
            },
            requestPage
        } = this.props;

        return (
            <CategoryPagination
                isLoading={isLoading}
                totalPages={totalPages}
                onPageSelect={requestPage}
            />
        );
    }

    render() {
        const {isLoading} = this.props;
        return (
            <main block="Magazine">
                <Loader isLoading={isLoading}/>
                <ContentWrapper label="Magazine">
                    {this.renderTitle()}
                    {this.getCategoryDescription()}
                    {this.renderTabs()}
                </ContentWrapper>
            </main>
        );
    }
}

export default Magazine;
